const ResultInRange = ["Negative", "Trace", "+1", "+2", "+3", "+4"];

export default ResultInRange;
